__turbopack_context__.v({
  "background": "LandingHero-module-scss-module__9JTFAq__background",
  "backgroundClip": "LandingHero-module-scss-module__9JTFAq__backgroundClip",
  "card": "LandingHero-module-scss-module__9JTFAq__card",
  "container": "LandingHero-module-scss-module__9JTFAq__container",
  "hero": "LandingHero-module-scss-module__9JTFAq__hero",
  "stage": "LandingHero-module-scss-module__9JTFAq__stage",
  "waiter": "LandingHero-module-scss-module__9JTFAq__waiter",
});
